import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { uploadAccessorialsApi } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = any & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorials>;

export const PopulateApiParameters: HandlerType = props => {
    const { file } = props.parameter;
    props.apiParameter = {
        file,
    };
};

export const UploadAccessorial: HandlerType = async props => {
    try {
        await uploadAccessorialsApi(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && (error.status === 400 || error.status === 409)) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, UploadAccessorial, ExecuteOnSuccess];

const uploadAccessorials = createHandlerChainRunner(chain, "UploadAccessorials");
export default uploadAccessorials;
